import { render, staticRenderFns } from "./IntroWithInfo.vue?vue&type=template&id=621f2744&scoped=true&"
import script from "./IntroWithInfo.vue?vue&type=script&lang=js&"
export * from "./IntroWithInfo.vue?vue&type=script&lang=js&"
import style0 from "./IntroWithInfo.vue?vue&type=style&index=0&id=621f2744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f2744",
  null
  
)

export default component.exports